(() => {
  const states = new WeakMap();
  const widgets = new Set();

  function cards(widget) {
    return [...widget.querySelectorAll('.jdgm-card:not([data-clone-type])')];
  }

  function clearTimer(state) {
    window.clearTimeout(state.timer);
    state.timer = null;
  }

  function syncControls(widget, state) {
    const text = state.userPaused ? 'Resume reviews' : 'Pause reviews';
    if (state.control.textContent !== text) state.control.textContent = text;
    state.control.setAttribute('aria-pressed', String(state.userPaused));
    widget.querySelector('.jdgm-videos-container')?.setAttribute(
      'aria-live', state.userPaused ? 'polite' : 'off'
    );
  }

  function schedule(widget, state) {
    clearTimer(state);
    syncControls(widget, state);
    const interval = state.interval;
    state.control.hidden = !interval;
    if (!widget.isConnected || state.userPaused || document.hidden ||
        !interval || cards(widget).length < 2) return;
    state.timer = window.setTimeout(() => {
      state.timer = null;
      if (!widget.isConnected) {
        widgets.delete(widget);
        return;
      }
      advance(widget, state, 1);
    }, interval);
  }

  function advance(widget, state, direction) {
    const reviews = cards(widget);
    if (reviews.length < 2) return;
    state.index = (state.index + direction + reviews.length) % reviews.length;
    state.id = reviews[state.index].getAttribute('data-review-id');
    update(widget);
  }

  function update(widget) {
    const allCards = [...widget.querySelectorAll('.jdgm-card')];
    const reviews = cards(widget);
    if (!reviews.length) return;

    let state = states.get(widget);
    if (!state) {
      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'scuba-review-autoplay-toggle';
      widget.append(control);
      const seconds = Number(widget.getAttribute('data-transition-speed'));
      state = {
        index: 0, id: null, timer: null, control,
        interval: Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : 0,
        userPaused: false
      };
      states.set(widget, state);
      widgets.add(widget);
      widget.addEventListener('click', event => {
        if (event.target.closest('.scuba-review-autoplay-toggle')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          state.userPaused = !state.userPaused;
          schedule(widget, state);
          return;
        }
        const arrow = event.target.closest('.jdgm-arrow');
        if (!arrow || !widget.contains(arrow)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const arrows = [...widget.querySelectorAll('.jdgm-arrow')];
        advance(widget, state, arrow === arrows[0] ? -1 : 1);
      }, true);
    }

    const retained = reviews.findIndex(card => card.getAttribute('data-review-id') === state.id);
    state.index = retained >= 0 ? retained : Math.min(state.index, reviews.length - 1);
    state.id = reviews[state.index].getAttribute('data-review-id');
    allCards.forEach(card => {
      const active = card === reviews[state.index];
      card.toggleAttribute('data-scuba-active-review', active);
      card.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    widget.querySelectorAll('.jdgm-arrow').forEach(arrow => {
      arrow.disabled = reviews.length < 2;
    });
    widget.setAttribute('data-scuba-carousel-ready', 'true');
    schedule(widget, state);
  }

  function start() {
    const detail = document.querySelector('.product-detail__detail');
    if (!detail) return;
    let scheduled = false;
    const scan = () => {
      widgets.forEach(widget => {
        if (widget.isConnected) return;
        clearTimer(states.get(widget));
        widgets.delete(widget);
      });
      detail.querySelectorAll('.jdgm-cards-carousel').forEach(update);
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        scan();
      });
    }).observe(detail, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', () => {
      widgets.forEach(widget => schedule(widget, states.get(widget)));
    });
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
